import { getRatesEnterpriseCityByIdRequest } from "../../data/ratesEnterpriseCityApi";

function getPayloadData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getTarifaEnterpriseCityByIdUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa ciudad a ciudad es obligatorio.");
  }

  return getPayloadData(await getRatesEnterpriseCityByIdRequest(id));
}
